/**
 * How-to film URLs. Desktop and mobile are separate destinations so a phone
 * opens the mobile player and a laptop opens the full site.
 */

/** Laptop and desktop walkthrough. */
export const HOW_TO_URL_DESKTOP = 'https://www.youtube.com/watch?v=xqM0OVLCSUc';

/** Phone and tablet walkthrough (YouTube Shorts). */
export const HOW_TO_URL_MOBILE = 'https://www.youtube.com/shorts/W7ZKjVygqIY';

const MOBILE_UA_RE = /Android|iPhone|iPad|iPod|Mobile/i;

/**
 * @param {string} query
 * @returns {boolean}
 */
function matchesMedia(query) {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(query).matches;
}

/**
 * True for a phone or tablet. A narrowed laptop window stays on the desktop URL.
 *
 * @param {{ userAgent?: string, coarsePointer?: boolean, narrowViewport?: boolean }} [signals]
 * @returns {boolean}
 */
export function isMobileHowToClient(signals) {
  const ua =
    signals && Object.prototype.hasOwnProperty.call(signals, 'userAgent')
      ? String(signals.userAgent || '')
      : typeof navigator !== 'undefined'
        ? String(navigator.userAgent || '')
        : '';
  if (MOBILE_UA_RE.test(ua)) return true;
  const coarse =
    signals && Object.prototype.hasOwnProperty.call(signals, 'coarsePointer')
      ? Boolean(signals.coarsePointer)
      : matchesMedia('(pointer: coarse)');
  const narrow =
    signals && Object.prototype.hasOwnProperty.call(signals, 'narrowViewport')
      ? Boolean(signals.narrowViewport)
      : matchesMedia('(max-width: 768px)');
  return Boolean(coarse && narrow);
}

/**
 * @param {boolean} [isMobile]
 * @returns {string}
 */
export function resolveHowToUrl(isMobile) {
  const mobile = typeof isMobile === 'boolean' ? isMobile : isMobileHowToClient();
  return mobile ? HOW_TO_URL_MOBILE : HOW_TO_URL_DESKTOP;
}
